/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Pale_Horse_AskInputs */

const en_deep_pale_horse_ask = /** @type {(inputs: Deep_Pale_Horse_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record`)
};

const de_deep_pale_horse_ask = /** @type {(inputs: Deep_Pale_Horse_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensatz`)
};

/**
* | output |
* | --- |
* | "Record" |
*
* @param {Deep_Pale_Horse_AskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_pale_horse_ask = /** @type {((inputs?: Deep_Pale_Horse_AskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Pale_Horse_AskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_pale_horse_ask(inputs)
	return de_deep_pale_horse_ask(inputs)
});